export const REFUND_APPROVAL_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'WITHDRAWN', 'EXECUTED'];
export class RefundApprovalsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(query = {}) {
        const qs = new URLSearchParams({
            ...(query.status !== undefined ? { status: query.status } : {}),
            ...(query.subject !== undefined ? { subject: query.subject } : {}),
            ...(query.limit !== undefined ? { limit: String(query.limit) } : {}),
        });
        const tail = qs.toString();
        return this.client.request({ method: 'GET', path: `/v1/refund-approvals${tail === '' ? '' : `?${tail}`}`, auth: true });
    }
    get(approvalId) {
        return this.client.request({ method: 'GET', path: `/v1/refund-approvals/${encodeURIComponent(approvalId)}`, auth: true });
    }
    decide(approvalId, input) {
        return this.client.request({ method: 'POST', path: `/v1/refund-approvals/${encodeURIComponent(approvalId)}/decision`, body: { decision: input.decision, reason: input.reason }, auth: true });
    }
    /**
     * The answer carries the real state in `compensation` (D833): a REFUND/COUPON answers its four-eyes `approval`, a RIDER_CREDIT the wallet
     * `adjustment`; `executed` is true only when money or credit moved.
     */
    proposeCompensation(ticketId, input) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${encodeURIComponent(ticketId)}/compensation-proposal`, body: { ...input }, auth: true });
    }
}
//# sourceMappingURL=refund-approvals.js.map